export default __webpack_public_path__ + "static/media/profile-create.c30eebfc.svg";